module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M52.9 54.3H9V22.4h43.9v31.9zm-40.7-3.2h37.4V25.7H12.2v25.4z","fill":"#878787"}}),_c('path',{attrs:{"d":"M22 38.5h3.3v14.2H22zM37.7 24H41v14.2h-3.3zM10.6 35.1h6.6v3.3h-6.6z","fill":"#878787"}}),_c('circle',{attrs:{"cx":"31.8","cy":"19.5","fill":"#fff","r":"13.5"}}),_c('path',{attrs:{"d":"M24.1 19.3l6.8 8.2 6.9-8.2h-4.3v-7.2h-5.2v7.2z"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-icons/quickstart_icon_openfloorplan.svg
// module id = 714
// module chunks = 2